import { useRef } from 'react';
import styles from './Selector.module.scss';

interface IProps {
  label: string;
  isChecked: boolean;
  onSelect: () => void;
}

// TODO: disabled, error states not implemented yet
export const Selector = ({ label, isChecked, onSelect }: IProps) => {
  // random constant id
  const idRef = useRef('selector' + Math.trunc(Math.random() * 100000));

  return (
    <div className={styles.selector}>
      <input type="checkbox"
             id={idRef.current}
             checked={isChecked}
             className={styles.selectorHiddenInput}
             onChange={onSelect}
      />
      <label htmlFor={idRef.current} className={styles.selectorLabel}>{label}</label>
    </div>
  );
};
  